// extracted by mini-css-extract-plugin
export default {"separator":"SkeletonLoadingScreen_separator__OuvaB","container":"SkeletonLoadingScreen_container__VInKz"};